module.exports = "<a\n  class=\"Link\"\n  ng-href=\"{{::ctrl.email && 'mailto:' + ctrl.supportEmail || undefined}}\">\n  {{::ctrl.text || ctrl.supportEmail}}\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/support_email/support_email.html
// module id = 340
// module chunks = 24